import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useSiteSearch } from "../context/SiteSearchContext";

const SearchResults = () => {
  const location = useLocation();
  const { results, performSearch, loading } = useSiteSearch();

  const params = new URLSearchParams(location.search);
  const searchQuery = params.get("q") || "";

  const getFinalPath = (item: any) => {
    switch (item.source_type) {
      case "product":
        return `${item.path}?id=${item.source_id}`;

      case "subcategory":
        return `${item.path}?id=${item.source_id}&name=${encodeURIComponent(item.title)}`;

      case "category":
        return `${item.path}?id=${item.source_id}&name=${encodeURIComponent(item.title)}`;

      case "service":
        return item.path;

      case "page":
        return item.path;

      default:
        return item.path;
    }
  };

  const getImageUrl = (item: any) => {
    if (item.source_type === "product" && item.image_path) {
      return `${import.meta.env.VITE_LYRAZONE_IMAGE_URL}/uploads/products/${item.source_id}/${item.image_path}`;
    }

    return null;
  };

  useEffect(() => {
    const runSearch = async () => {
      await performSearch(searchQuery);
    };

    runSearch();
  }, [searchQuery]);

  return (
    <section className="search-page container">
      <h2 className="search-title">Search Results</h2>

      <p className="search-subtitle">
        Showing results for: <strong>{searchQuery}</strong>
      </p>

      {loading ? (
        <div className="search-empty">Loading...</div>
      ) : results.length === 0 ? (
        <div className="search-empty">No results found.</div>
      ) : (
        <div className="search-grid">
          {results.map((item: any) => {
            const imageUrl = getImageUrl(item);

            return (
              <Link
                to={getFinalPath(item)}
                key={item.id}
                className="search-card"
              >
                {imageUrl && (
                  <img
                    src={imageUrl}
                    alt={item.title}
                    className="search-card-image"
                  />
                )}

                <h4>{item.title}</h4>
                <p>{item.content}</p>
                <span>{getFinalPath(item)}</span>
              </Link>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default SearchResults;
